import AES from '@/assets/util/AES'
import {
  getBannerList,
  getActor,
  postFirend,
  getHeader,
  getNewlist,
  getYear,
  OpenGUIDFile,
  getPDF,
  getPDFnew,
  getHtmlRead,
  getList,
  getLista,
  getListb,
  getXZCS,
  getPLLB,
  postMassage,
  postSearch,
  postThirdRegister,
  getLBXQ,
  getXZPH,
  getDCJK,
  getWZDC,
  getgok,
  getSet,
  getLLCS,
  getAllSum,
  postLogin,
  getVerificationcode,
  getVerificationcodeImg,
  getRegDeteCt,
  getForgetPassword,
  getForgetPasswordGroup,
  getIsRegistered,
  getRegSendCode,
  postRegist,
  getLM,
  getSFXS,
  postNDCJ,
  GetRouter,
  getXKLX,
  getdetailes,
  getOAViewTJ,
  GetRss,
  GetRssycb,
  GetscriptRssycb,
  getGetQrcode,
  GetToken,
  getWeiXinLogin,
  GetFloatingAds,
  getdownXML,
  getMMDL,
  GetScriptPrePrintDetailed,
  IssueDownLoad,
  OpenFilebyGuid,
  OpenMessageFilebyGuid,
  EamilVerification,
  NoLoginChangePassword,
  GetYearIssueList,
  GetArticleIDByNum,
  PostSubscribe,
  UnSubscribe,
  GetIssueList,
  getReSetPassword,
  ForgetPasswordByGuid,
  GetArticleAbstractInfo,
} from '@/assets/util/Link'

const Admin = {
  //高级检索学科领域是否显示
  async _getMMDL(state, data) {
    return getMMDL(data)
  },
  //高级检索学科领域是否显示
  async _getXKLX(state, data) {
    return getXKLX(data)
  },
  //高级检索栏目领域是否显示
  async _getSFXS(state, data) {
    return getSFXS(data)
  },
  //预出版详情
  async _GetScriptPrePrintDetailed(state, data) {
    return GetScriptPrePrintDetailed(data)
  },

  //年度区间接口
  async _postNDCJ(state, data) {
    return postNDCJ(data)
  },
  //高级检索栏目接口
  async _getLM(state, data) {
    return getLM(data)
  },
  //注册
  async _postRegist(state, data) {
    return postRegist(data)
  },
  async _GetRouter(state, data) {
    return GetRouter(data)
  },

  async _GetRss(state, data) {
    return GetRss(data)
  },
  async _GetRssycb(state, data) {
    return GetRssycb(data)
  },
  async _GetscriptRssycb(state, data) {
    return GetscriptRssycb(data)
  },
  //发送验证码
  async _getRegSendCode(state, data) {
    return getRegSendCode(data)
  },
  //找回密码
  async _getForgetPassword(state, data) {
    return getForgetPassword(data)
  },
  async _getReSetPassword(state, data) {
    return getReSetPassword(data)
  },
  async _ForgetPasswordByGuid(state, data) {
    return ForgetPasswordByGuid(data)
  },
  async _getForgetPasswordGroup(state, data) {
    return getForgetPasswordGroup(data)
  },
  //找回密码页面添加相同邮箱和手机号所有账号列表
  async _getIsRegistered(state, data) {
    return getIsRegistered(data)
  },
  //判断手机号邮箱是否注册过
  async _getRegDeteCt(state, data) {
    return getRegDeteCt(data)
  },
  //获取页面验证码
  async _getVerificationcode(state, data) {
    return getVerificationcode(data)
  },
  async _getVerificationcodeImg(state) {
    return getVerificationcodeImg()
  },
  //登录
  async _postLogin(state, data) {
    return postLogin(data)
  },
  //文献导出
  async _getWZDC(state, data) {
    return getWZDC(data)
  },
  //
  async _getDCJK(state, data) {
    return getDCJK(data)
  },
  //检索
  async _getXZPH(state, data) {
    return getXZPH(data)
  },
  //检索
  async _postSearch(state, data) {
    return postSearch(data)
  },
  //qq登录
  async _postThirdRegister(state, data) {
    return postThirdRegister(data)
  },
  // 获取轮播图
  async _getBannerList(state, data) {
    return getBannerList(data)
  },
  //期刊社动态/作者营地
  async _getActor(state, data) {
    return getActor(data)
  },
  //友情链接
  async _postFirend(state, data) {
    return postFirend(data)
  },
  //期刊简介
  async _getHeader(state, data) {
    return getHeader(data)
  },
  //首页最新一期
  async _getNewlist(state, data) {
    return getNewlist(data)
  },
  //最新一期
  async _getYear(state, data) {
    return getYear(data)
  },
  //首页封面，封底，目次打开文件
  async _OpenGUIDFile(state, data) {
    return OpenGUIDFile(data)
  },
  //下载pdf
  async _getPDF(state, data) {
    data.Id = AES.encrypt(data.Id.toString(), 'Samson*@Samson*@')
    return getPDF(data)
  },
  //下载pdfnew
  async _getPDFnew(state, data) {
    //data.Id=AES.encrypt((data.Id).toString(),"Samson*@Samson*@")
    data.Id = data.Id
    return getPDFnew(data)
  },
  //预出版

  async _getList(state, data) {
    return getList(data)
  },
  //html浏览次数+1
  async _getHtmlRead(state, data) {
    return getHtmlRead(data)
  },

  async _getLista(state, data) {
    return getLista(data)
  },

  async _getListb(state, data) {
    return getListb(data)
  },

  async _getXZCS(state, data) {
    return getXZCS(data)
  },
  async _getLBXQ(state, data) {
    return getLBXQ(data)
  },

  async _getPLLB(state, data) {
    return getPLLB(data)
  },
  async _getdownXML(state, data) {
    return getdownXML(data)
  },
  async _postMassage(state, data) {
    return postMassage(data)
  },
  async _getgok(state, data) {
    return getgok(data)
  },

  async _getSet(state, data) {
    return getSet(data)
  },

  async _getLLCS(state, data) {
    return getLLCS(data)
  },

  async _getOAViewTJ(state, data) {
    return getOAViewTJ(data)
  },
  async _getAllSum(state, data) {
    return getAllSum(data)
  },
  //首页广告获取
  async _GetFloatingAds(state, data) {
    return GetFloatingAds(data)
  },
  async _getdetailes(state, data) {
    return getdetailes(data)
  },
  //weixin登录
  async _getGetQrcode(state, data) {
    return getGetQrcode(data)
  }, //weixin登录
  async _getWeiXinLogin(state, data) {
    return getWeiXinLogin(data)
  },

  async _GetToken(state, data) {
    return GetToken(data)
  },
  async _OpenFilebyGuid(state, data) {
    return OpenFilebyGuid(data)
  },

  async _OpenMessageFilebyGuid(state, data) {
    return OpenMessageFilebyGuid(data)
  },
  async _IssueDownLoad(state, data) {
    return IssueDownLoad(data)
  },

  async _EamilVerification(state, data) {
    return EamilVerification(data)
  },

  async _NoLoginChangePassword(state, data) {
    return NoLoginChangePassword(data)
  },
  async _GetYearIssueList(state, data) {
    return GetYearIssueList(data)
  },
  async _GetArticleIDByNum(state, data) {
    return GetArticleIDByNum(data)
  },
  async _PostSubscribe(state, data) {
    return PostSubscribe(data)
  },
  async _UnSubscribe(state, data) {
    return UnSubscribe(data)
  },
  async _GetIssueList(state, data) {
    return GetIssueList(data)
  },
  async _GetArticleAbstractInfo(state, data) {
    return GetArticleAbstractInfo(data)
  },
}
export default Admin
